import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  root: {
    maxWidth: "100%",
    padding: 0,
    justifyContent: "flex-start",
    paddingInline: spacing(0.5),
    background: "transparent",
  },
  button: {
    textTransform: "none",
    border: `1px solid ${palette.separator.main}`,
    color: grey[800],
    lineHeight: 1,
    padding: spacing(0.5, 1.5),
    borderRadius: spacing(1),
    height: 42,
    width: 114,
    gap: spacing(1),
  },
  activeButton: {
    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,
  },
  connector: {
    maxWidth: spacing(2),
    minWidth: spacing(2),
    height: 1,
  },
}));

export default styles;
